export interface ViewerLoadError {
  name?: string;
  message?: string;
}

/** Viewer error names (from @react-pdf-viewer/core's LoadError) that a signed-URL re-mint can
 * never fix — the downloaded bytes are the problem, not the URL. */
const NON_RETRYABLE_VIEWER_ERROR_NAMES = new Set([
  "PasswordException",
  "InvalidPDFException",
  "FormatError",
]);

export function isRetryableViewerLoadError(error?: ViewerLoadError): boolean {
  return !error?.name || !NON_RETRYABLE_VIEWER_ERROR_NAMES.has(error.name);
}
